import React from 'react';

const StarIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none" {...rest}>
      <path d="M8.03493 0.592095C8.42969 -0.197365 9.57031 -0.197365 9.96507 0.592095L11.9125 4.48656C12.0693 4.80006 12.3723 5.01735 12.7228 5.06762L17.0774 5.69213C17.9601 5.81872 18.3126 6.88937 17.6738 7.50388L14.5228 10.5353C14.2692 10.7793 14.1534 11.1309 14.2133 11.4755L14.9572 15.7559C15.108 16.6236 14.1852 17.2853 13.3956 16.8756L9.5008 14.8547C9.18728 14.692 8.81272 14.692 8.4992 14.8547L4.60436 16.8756C3.81482 17.2853 2.89205 16.6236 3.04283 15.7559L3.78668 11.4755C3.84656 11.1309 3.73082 10.7793 3.47717 10.5353L0.326178 7.50388C-0.312569 6.88937 0.0398995 5.81872 0.922627 5.69213L5.27719 5.06762C5.62772 5.01735 5.93074 4.80006 6.08751 4.48656L8.03493 0.592095Z" fill="#C3C5CA"/>
    </svg>
  );
};

export default StarIcon;